import successCode from './successCode'

export default {
    successCode,
}

